export const singleView = `<svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.519409" y="0.56897" width="15.3613" height="6.98242" rx="1" fill="white"/>
<rect x="17.2776" y="0.56897" width="6.98242" height="6.98242" rx="1" fill="white"/>
</svg>
`;
